// extracted by mini-css-extract-plugin
export default {"container":"NavMenu_container__5cX0C","departmentsContainer":"NavMenu_departmentsContainer__gZA23","menuItem":"NavMenu_menuItem__qxVut"};